export enum LogAcaoCliente {
  CENTRAL_ATENDIMENTO = 'CENTRAL_ATENDIMENTO',
  CARTAO_CASAS_BAHIA = 'CARTAO_CASAS_BAHIA',
  CARTAO_PONTO = 'CARTAO_PONTO',
  COMPRA_CARNE = 'COMPRA_CARNE',
}
